// extracted by mini-css-extract-plugin
export default {"swipeLeft":"swipe-left_swipeLeft__z3H4M","moveSwipe":"swipe-left_moveSwipe__QfawM","scroll":"swipe-left_scroll__SVnVU"};